<template>

  <div v-if="!isFrame" class="main-wrapper bg-gray-900 text-gray-100">
    <!-- Отображаем Header, если не на странице /iframe -->

    <HeaderComponent />
    <router-view />

    <!-- Отображаем TabNavigation, если не на странице /iframe -->
    <TabNavigation />
  </div>
  <div v-else>
    
    <!-- <GoogleTranslator /> -->
    <FrameView></FrameView>
  </div>


</template>

<script setup>
import HeaderComponent from './components/HeaderComponent.vue';
import TabNavigation from './components/TabNavigation.vue';
import FrameView from './components/FrameView.vue';
// import GoogleTranslator from "./components/GoogleTranslator.vue"
const isFrame = window.location.pathname.includes("frame")

</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');

body {
  font-family: 'Roboto', sans-serif;

}

</style>
